import React from 'react';
import {
  Build,
  GpsFixed,
  Description,
  Security,
  Business,
  DirectionsCar,
  SailingOutlined,
  PersonOutline,
} from '@mui/icons-material';

/**
 * Get service icon based on service type
 * @param type - The service type
 * @returns React icon component
 */
export const getServiceIcon = (type: string) => {
  switch (type?.toLowerCase()) {
    case 'inspection':
      return <Build />;
    case 'gps':
      return <GpsFixed />;
    case 'documentation':
      return <Description />;
    case 'insurance':
      return <Security />;
    case 'cars':
    case 'car':
      return <DirectionsCar />;
    case 'yachts':
    case 'yacht':
      return <SailingOutlined />;
    case 'drivers':
    case 'driver':
      return <PersonOutline />;
    default:
      return <Business />;
  }
};

/**
 * Get service color based on service type
 * @param type - The service type
 * @returns Material-UI color string
 */
export const getServiceColor = (type: string) => {
  switch (type?.toLowerCase()) {
    case 'inspection':
      return 'primary';
    case 'gps':
      return 'success';
    case 'documentation':
      return 'info';
    case 'insurance':
      return 'warning';
    case 'cars':
    case 'car':
      return 'primary';
    case 'yachts':
    case 'yacht':
      return 'info';
    case 'drivers':
    case 'driver':
      return 'secondary';
    default:
      return 'default';
  }
};

// Make these functions globally available as a fallback
if (typeof window !== 'undefined') {
  (window as any).getServiceIcon = getServiceIcon;
  (window as any).getServiceColor = getServiceColor;
}